import { AUDIO_CHANNEL_CONFIG } from "../constants/audioChannels";
import { AudioSettingsItem, NormalizedAudioSettingsItem } from "../types";

export const normalizeAudioSettingsItems = (items: AudioSettingsItem[]): NormalizedAudioSettingsItem[] =>
  items.map((item) => {
    if (typeof item === "string") {
      return {
        channel: item,
        scope: AUDIO_CHANNEL_CONFIG[item].defaultScope,
      };
    }

    return {
      channel: item.channel,
      scope: item.scope ?? AUDIO_CHANNEL_CONFIG[item.channel].defaultScope,
    };
  });
